//BootstrapStarterCardFavoriteStylesContainer.jsx
import React from 'react';
import { Button } from 'react-bootstrap';

const BootstrapStarterCardFavoriteStylesContainer = ({
    favoriteStyleVisibilityMap,
    savedStyles,
    optionsBoxPositions,
    setOptionsBoxPositions,
    showOptionsBox,
    setShowOptionsBox,
    optionsBoxRefs
}) => {
    return (
        <div id="fixedPositionFavoriteStylesContainer"
            className="fixedPositionFavoriteStylesContainer"
        >
            <div style={{ fontWeight: 'bold', marginBottom: '6px' }}
                id="fixedPositionFavoriteStylesContainerHeader"
                className="fixedPositionFavoriteStylesContainerHeader"
            >
                {/* Fixed Position Favorite Styles Container */}
            </div>

            <div className="fixedPositionFavoriteStylesContainerOuter">
                <div id="fixedPositionFavoriteStylesContainerInner" className="fixedPositionFavoriteStylesContainerInner">
                    {Object.entries(favoriteStyleVisibilityMap).map(([index, isVisible]) =>
                        isVisible ? (
                            <div
                                key={`favButtonGroupBox-${index}`}
                                id={`favButtonGroupBox-${index}`}
                                className="d-flex flex-column m-2"
                            >
                                <div
                                    id={`favButtonContainerOuter-${index}`}
                                    className="favButtonContainerOuter"
                                >
                                    <div
                                        id="favButtonContainerInner"
                                        className="favButtonContainerInner"
                                    >
                                        {/* Fav Fresh Apply BUTTON */}
                                        <div
                                            className="favButtonContainerInnerButtonLeftBoxForButton"
                                        >
                                            <Button
                                                id={`favButtonContainerInnerButtonLeft-${index}`}
                                                className="favButtonContainerInnerButtonLeft"
                                                size="sm"
                                            >
                                                <div
                                                    className="favButtonContainerInnerButtonLeftBoxImageAndText"
                                                    id={`buttonFavoriteSavedStylesForStylebar-${index}`}
                                                    size="sm"
                                                    variant="success"
                                                    onClick={() => {
                                                        // Find and click the corresponding FRESH APPLY button in the ToolSavedStylesContainer
                                                        const freshApplyButton = document.getElementById(`buttonClearStylingThenApplySavedStyle-${index}`);
                                                        if (freshApplyButton) {
                                                            freshApplyButton.click();
                                                        } else {
                                                            console.warn(`Could not find FRESH APPLY button for style index ${index}`);
                                                        }
                                                    }}
                                                >
                                                    <div
                                                        id="favButtonContainerInnerButtonLeftBoxImage"
                                                        className="favButtonContainerInnerButtonLeftBoxImage"
                                                    >
                                                        <img
                                                            id="favButtonContainerInnerButtonLeftBoxImageImg"
                                                            src="/SVGicons/magicwand-black.svg"
                                                            alt="Apply Saved Style"
                                                        />
                                                    </div>
                                                    <div
                                                        id="favButtonContainerInnerButtonLeftBoxText"
                                                        className="favButtonContainerInnerButtonLeftBoxText"
                                                    >
                                                        {savedStyles[index]?.name || 'Unknown'}
                                                    </div>
                                                </div>
                                            </Button>
                                        </div>

                                        <div
                                            className="favButtonContainerInnerButtonRightBoxForButtonAndExposedButtons"
                                        >
                                            {/* Fav Options BUTTON to Reveal Exposing Container */}
                                            <Button
                                                id={`favButtonContainerInnerButtonRight-${index}`}
                                                className="favButtonContainerInnerButtonRight"
                                                size="sm"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    const buttonRect = e.currentTarget.getBoundingClientRect();
                                                    const dropdownWidth = 200;
                                                    const position = {
                                                        top: buttonRect.top + window.scrollY - 10,
                                                        left: buttonRect.left + (buttonRect.width / 2) - (dropdownWidth / 2) + window.scrollX,
                                                    };

                                                    setOptionsBoxPositions(prev => ({
                                                        ...prev,
                                                        [index]: position
                                                    }));

                                                    setShowOptionsBox((prev) => ({
                                                        ...prev,
                                                        [index]: !prev[index]
                                                    }));
                                                }}
                                            >
                                                <div className="favButtonContainerInnerButtonRightBoxImg">
                                                    <img
                                                        src="/SVGicons/three-dots-vertical-black.svg"
                                                        alt="Saved Style Options"
                                                    />
                                                </div>
                                            </Button>

                                            {/* Fav Options Exposing Container */}
                                            {showOptionsBox[index] && (
                                                <div
                                                    id={`favButtonContainerInnerButtonRightOptionsButtonBox-${index}`}
                                                    className="favButtonContainerInnerButtonRightOptionsButtonBox"
                                                    ref={(el) => (optionsBoxRefs.current[index] = el)}
                                                >
                                                    <div
                                                        className="favButtonContainerInnerButtonRightOptionsButtonBoxContainer"
                                                        style={{
                                                            top: optionsBoxPositions[index]?.top || 170,
                                                            left: optionsBoxPositions[index]?.left || 120,
                                                        }}
                                                    >
                                                        <div className="favOptionsButtonBoxContainer01">
                                                            <Button
                                                                id={`buttonFavoriteSavedStylesForStylebar-${index}`}
                                                                size="sm"
                                                                variant="success"
                                                                className="mb-1 buttonFreshApplyFavoriteSavedStylesForStylebarRevealed"
                                                                style={{
                                                                    padding: '2px 6px',
                                                                    fontSize: '0.65rem',
                                                                    fontWeight: 'bold'
                                                                }}
                                                                onClick={() => {
                                                                    // Find and click the corresponding FRESH APPLY button in the ToolSavedStylesContainer
                                                                    const freshApplyButton = document.getElementById(`buttonClearStylingThenApplySavedStyle-${index}`);
                                                                    if (freshApplyButton) {
                                                                        freshApplyButton.click();
                                                                    } else {
                                                                        console.warn(`Could not find FRESH APPLY button for style index ${index}`);
                                                                    }
                                                                }}
                                                            >
                                                                <div
                                                                    id="buttonFreshApplyFavoriteSavedStylesForStylebarButtonBox"
                                                                    className="buttonFreshApplyFavoriteSavedStylesForStylebarButtonBox"
                                                                >
                                                                    <div
                                                                        id="buttonFreshApplyFavoriteSavedStylesForStylebarButtonBoxImage"
                                                                        className="buttonFreshApplyFavoriteSavedStylesForStylebarButtonBoxImage"
                                                                    >
                                                                    </div>
                                                                    <div
                                                                        id="buttonFreshApplyFavoriteSavedStylesForStylebarButtonBoxText"
                                                                        className="buttonFreshApplyFavoriteSavedStylesForStylebarButtonBoxText"
                                                                    >
                                                                        FRESH APPLY: {savedStyles[index]?.name || 'Unknown'}
                                                                    </div>
                                                                </div>
                                                            </Button>
                                                        </div>
                                                        <div className="favOptionsButtonBoxContainer02">
                                                            <Button
                                                                id={`buttonMergeApplyFavoriteSavedStylesForStylebar-${index}`}
                                                                size="sm"
                                                                variant="success"
                                                                className="mb-1 buttonMergeApplyFavoriteSavedStylesForStylebarRevealed"
                                                                style={{
                                                                    padding: '2px 6px',
                                                                    fontSize: '0.65rem',
                                                                    fontWeight: 'bold'
                                                                }}
                                                                onClick={() => {
                                                                    const mergeApplyButton = document.getElementById(`buttonSavedStyleApply-${index}`);
                                                                    if (mergeApplyButton) {
                                                                        mergeApplyButton.click();
                                                                    } else {
                                                                        console.warn(`Could not find MERGE APPLY button for style index ${index}`);
                                                                    }
                                                                }}
                                                            >
                                                                <div
                                                                    id="buttonMergeApplyFavoriteSavedStylesForStylebarButtonBox"
                                                                    className="buttonMergeApplyFavoriteSavedStylesForStylebarButtonBox"
                                                                >
                                                                    <div
                                                                        id="buttonMergeApplyFavoriteSavedStylesForStylebarButtonBoxImage"
                                                                        className="buttonMergeApplyFavoriteSavedStylesForStylebarButtonBoxImage"
                                                                    >
                                                                    </div>
                                                                    <div
                                                                        id="buttonMergeApplyFavoriteSavedStylesForStylebarButtonBoxText"
                                                                        className="buttonMergeApplyFavoriteSavedStylesForStylebarButtonBoxText"
                                                                    >
                                                                        MERGE APPLY: {savedStyles[index]?.name || 'Unknown'}
                                                                    </div>
                                                                </div>
                                                            </Button>
                                                        </div>
                                                        <div className="favOptionsButtonBoxContainer03">
                                                            <Button
                                                                id={`buttonREMOVEFavoriteSavedStylesForStylebar-${index}`}
                                                                size="sm"
                                                                variant="outline-danger"
                                                                className="mb-1 buttonRemoveFromFavoriteSavedStylesForStylebarRevealed"
                                                                style={{
                                                                    padding: '2px 6px',
                                                                    fontSize: '0.65rem',
                                                                    fontWeight: 'bold'
                                                                }}
                                                                onClick={() => {
                                                                    const removeButton = document.getElementById(`buttonRemoveFromFavoriteSavedStyles-${index}`);
                                                                    if (removeButton) {
                                                                        removeButton.click();
                                                                    } else {
                                                                        console.warn(`Could not find REMOVE button for style index ${index}`);
                                                                    }
                                                                }}
                                                            >
                                                                <div
                                                                    id="buttonRemoveFromFavoriteSavedStylesForStylebarButtonBox"
                                                                    className="buttonRemoveFromFavoriteSavedStylesForStylebarButtonBox"
                                                                >
                                                                    <div
                                                                        id="buttonRemoveFromFavoriteSavedStylesForStylebarButtonBoxImage"
                                                                        className="buttonRemoveFromFavoriteSavedStylesForStylebarButtonBoxImage"
                                                                    >
                                                                    </div>
                                                                    <div
                                                                        id="buttonRemoveFromFavoriteSavedStylesForStylebarButtonBoxText"
                                                                        className="buttonRemoveFromFavoriteSavedStylesForStylebarButtonBoxText"
                                                                    >
                                                                        REMOVE from Favs: {savedStyles[index]?.name || 'Unknown'}
                                                                    </div>
                                                                </div>
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null
                    )}
                </div>
            </div>
        </div>
    );
};

export default BootstrapStarterCardFavoriteStylesContainer;